import React, { useCallback, useRef } from 'react'
import { Grid } from '@material-ui/core'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import { dataCatalog } from '../../../../api/coreData'
import Loading from '../../../molecules/Loading'
import EmptySection from '../../../atoms/EmptySection'
import SummitOnlyContent from '../../../atoms/SummitOnlyContent'
import SydButton from '../../../commonDesign/Button'
import FlexRow from '../../../molecules/FlexRow'
import MapTableDialog from './dialogs/MapTableDialog'
import DatasourceLayout from './shared/DatasourceLayout'

const SEARCH_VALUE = {
  filters: {
    type: 'table'
  },
  includes: {
    namespace: true
  }
}

function CatalogTables () {
  const { data, isLoading } = dataCatalog.useSearchCatalogDataSources(SEARCH_VALUE)
  const mapTableRef = useRef(null)
  const onMapTable = useCallback(() => {
    mapTableRef.current.open()
  }, [])

  if (isLoading) {
    return (
      <FadeIn key='loading'>
        <Loading />
      </FadeIn>
    )
  }

  if (!(data?.total || 0)) {
    return (
      <FadeIn key='no_data'>
        <EmptySection title='No Tables' description='' />
        <SummitOnlyContent>
          <FlexRow className='justify-center'>
            <SydButton
              variant='primary'
              size='md'
              icon='warning'
              onClick={onMapTable}
            >
              Map a Table
            </SydButton>
          </FlexRow>
          <MapTableDialog ref={mapTableRef} />
        </SummitOnlyContent>
      </FadeIn>
    )
  }

  return (
    <FadeIn key='tables'>
      <Grid container spacing={2}>
        <SummitOnlyContent>
          <Grid item xs={12}>
            <FlexRow className='justify-end'>
              <SydButton
                variant='primary'
                size='md'
                icon='warning'
                onClick={onMapTable}
              >
                Map a Table
              </SydButton>
              <MapTableDialog ref={mapTableRef} />
            </FlexRow>
          </Grid>
        </SummitOnlyContent>
        <Grid item xs={12}>
          <DatasourceLayout items={data?.data || []} />
        </Grid>
      </Grid>
    </FadeIn>
  )
}

CatalogTables.propTypes = {
}

export default CatalogTables
